<template>
    <div>
        <div class="delivery text_11" key="1" ref="delivery_container" v-if="!isDeliveresLoading">
            <template>
                <div class="delivery__has-delivery" key="has-delivery" v-if="deliveries && deliveries.length > 0">
                    <div class="delivery__tabs">
                        <div
                            class="delivery__tab"
                            :class="{
                                is_active: delivery.method.slug == currentDeliveryMethod,
                            }"
                            v-for="delivery in deliveries"
                            :key="'tab-' + delivery.method.slug"
                            @click="
                                currentDeliveryServiceIndex = 0;
                                currentDeliveryType = delivery.method.code;
                                currentDeliveryMethod = delivery.method.slug;
                            ">
                            {{ delivery.method.name }}
                        </div>
                        <div
                            class="delivery-shops-modal-toggler"
                            v-if="currentDeliveryType == 'pickup' && $device.isDesktop"
                            @click="isShowMap = !isShowMap">
                            <template v-if="!isShowMap"> {{ $t("stores_map") }} </template>
                            <template v-else>
                                {{ $t("hide_map") }}
                            </template>
                        </div>
                    </div>
                    <div
                        class="delivery-shops-modal-toggler"
                        v-if="currentDeliveryType == 'pickup' && !$device.isDesktop"
                        @click="isShowMap = !isShowMap">
                        <template v-if="!isShowMap">{{ $t("show_stores_on_map") }} </template>
                        <template v-else>
                            {{ $t("hide_map") }}
                        </template>
                    </div>
                    <div class="delivery__contents">
                        <transition name="fade" mode="out-in">
                            <div
                                class="delivery__content"
                                :class="'delivery__content--' + currentDeliveryMethod"
                                :key="currentDeliveryMethod">
                                <div v-if="currentDelivery && currentDelivery.method.code == 'courier'">
                                    <div class="form-group form-group--address" v-if="city">
                                        <div
                                            v-click-outside="
                                                () => {
                                                    localStreetInput.is_focus = false;
                                                    $emit('checkValueStreet');
                                                }
                                            "
                                            class="dadata-suggestions"
                                            :langg="langust">
                                            <div class="form-group__label">
                                                <div
                                                    class="form-group__label-reset"
                                                    v-if="streetInput.value"
                                                    @click="$emit('resetStreet')">
                                                    <svg-icon name="close--small" width="8" height="8" />
                                                </div>
                                                <template v-if="isCIS">
                                                    <input
                                                        ref="input"
                                                        :value="localStreetInput.value"
                                                        @input="
                                                            ($event) => {
                                                                localStreetInput.is_focus = true;
                                                                localStreetInput.value = $event.target.value;
                                                                $emit('update:setStreetInput', localStreetInput);
                                                                $emit('checkValueStreet');
                                                                $emit('get', $event);
                                                            }
                                                        "
                                                        type="text"
                                                        class="form-group__input"
                                                        name="street"
                                                        :class="{
                                                            is_focus: localStreetInput.is_focus,
                                                            is_changed: localStreetInput.is_changed,
                                                            is_invalid: !localBuildingInput.isValid,
                                                        }"
                                                        @click="
                                                            () => {
                                                                localStreetInput.is_focus = true;
                                                                $emit('update:setStreetInput', localStreetInput);
                                                                $emit('update:setStreet', localStreetInput.value);
                                                            }
                                                        "
                                                        autocomplete="false_disabled_hack@#!@#$" />
                                                    <div
                                                        class="form-group__float-label form-group__label--half text_11">
                                                        {{ localStreetInput.label }}
                                                        <span
                                                            v-if="localStreetInput.required"
                                                            class="form-group__required"
                                                            >*</span
                                                        >
                                                    </div>
                                                    <div
                                                        class="form-group__validation text_11"
                                                        v-if="!localStreetInput.isValid">
                                                        {{ localStreetInput.validationMessage }}
                                                    </div>
                                                    <transition name="fade">
                                                        <div
                                                            class="dadata-suggestions__list dadata-street text_13"
                                                            v-if="isShowStreetSuggestions"
                                                            :class="{ is_empty: !localStreetInput.suggestions.length }">
                                                            <div
                                                                class="dadata-suggestions__item"
                                                                v-for="(item, index) in localStreetInput.suggestions"
                                                                @click="
                                                                    () => {
                                                                        $emit('selectStreet', item);
                                                                    }
                                                                "
                                                                :key="index"
                                                                v-html="
                                                                    item.data.street_with_type.replace(
                                                                        re,
                                                                        '<mark>$&</mark>'
                                                                    )
                                                                "></div>
                                                        </div>
                                                    </transition>
                                                </template>
                                                <template v-else>
                                                    <input
                                                        ref="input"
                                                        v-model="localStreetInput.value"
                                                        type="text"
                                                        class="form-group__input"
                                                        name="street"
                                                        :class="{
                                                            is_focus: localStreetInput.is_focus,
                                                            is_changed: true,
                                                        }"
                                                        @input="
                                                            (localStreetInput.is_focus = true),
                                                                $emit('update:setStreetInput', localStreetInput),
                                                                $emit('update:setStreet', localStreetInput.value)
                                                        "
                                                        autocomplete="false_disabled_hack@#!@#$" />
                                                    <div
                                                        class="form-group__float-label form-group__label--half text_11">
                                                        {{ localStreetInput.label }}
                                                        <span
                                                            v-if="localStreetInput.required"
                                                            class="form-group__required"
                                                            >*</span
                                                        >
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="dadata-suggestions" :langg="langust">
                                            <div
                                                class="form-group__label form-group__label--building"
                                                :class="{ is_invalid: !localBuildingInput.isValid }">
                                                <div
                                                    class="form-group__label-reset"
                                                    v-if="localBuildingInput.value"
                                                    @click="$emit('resetStreet')">
                                                    <svg-icon name="close--small" width="8" height="8" />
                                                </div>
                                                <template v-if="isCIS">
                                                    <input
                                                        ref="input"
                                                        v-model="localBuildingInput.value"
                                                        type="text"
                                                        class="form-group__input form-group__input--building"
                                                        name="building"
                                                        v-click-outside="
                                                            () => {
                                                                localBuildingInput.is_focus = false;
                                                                $emit('update:setBuildingInput', localBuildingInput);
                                                                $emit('update:setBuilding', localBuildingInput.value);
                                                                $emit('checkValueBuilding');
                                                            }
                                                        "
                                                        :class="{
                                                            is_focus: localBuildingInput.is_focus,
                                                            is_changed: localBuildingInput.is_changed,
                                                            is_invalid: !localBuildingInput.isValid,
                                                        }"
                                                        @click="
                                                            (localBuildingInput.is_focus = true),
                                                                $emit('update:setBuildingInput', localBuildingInput),
                                                                $emit('update:setBuilding', localBuildingInput.value)
                                                        "
                                                        @input="
                                                            (localBuildingInput.is_focus = true),
                                                                $emit('update:setBuildingInput', localBuildingInput),
                                                                $emit('update:setBuilding', localBuildingInput.value),
                                                                $emit('checkValueBuilding'),
                                                                $emit('get', $event)
                                                        "
                                                        autocomplete="false_disabled_hack@#!@#$" />
                                                    <div
                                                        class="form-group__float-label form-group__label--half text_11">
                                                        {{ localBuildingInput.label }}
                                                        <span
                                                            v-if="localBuildingInput.required"
                                                            class="form-group__required"
                                                            >*</span
                                                        >
                                                    </div>
                                                    <div
                                                        class="form-group__validation text_11"
                                                        v-if="!localBuildingInput.isValid">
                                                        {{ localBuildingInput.validationMessage }}
                                                    </div>
                                                    <transition name="fade">
                                                        <div
                                                            class="dadata-suggestions__list dadata-street text_13"
                                                            v-if="isShowBuildingSuggestions"
                                                            :class="{
                                                                is_empty: !localBuildingInput.suggestions.length,
                                                            }">
                                                            <div
                                                                class="dadata-suggestions__item"
                                                                v-for="(item, index) in localBuildingInput.suggestions"
                                                                @click="$emit('selectBuilding', item)"
                                                                :key="index"
                                                                v-html="
                                                                    `${
                                                                        item.data.block
                                                                            ? item.data.house +
                                                                              item.data.block_type +
                                                                              item.data.block
                                                                            : item.data.house
                                                                    }`.replace(re, '<mark>$&</mark>')
                                                                "></div>
                                                        </div>
                                                    </transition>
                                                </template>
                                                <template v-else>
                                                    <input
                                                        ref="input"
                                                        v-model="localBuildingInput.value"
                                                        type="text"
                                                        class="form-group__input"
                                                        name="building"
                                                        :class="{
                                                            is_focus: localBuildingInput.is_focus,
                                                            is_changed: localBuildingInput.value,
                                                        }"
                                                        @input="
                                                            (localBuildingInput.is_focus = true),
                                                                $emit('update:setBuildingInput', localBuildingInput),
                                                                $emit('update:setBuilding', localBuildingInput.value)
                                                        "
                                                        autocomplete="false_disabled_hack@#!@#$" />
                                                    <div
                                                        class="form-group__float-label form-group__label--half text_11">
                                                        {{ localBuildingInput.label }}
                                                        <span
                                                            v-if="localBuildingInput.required"
                                                            class="form-group__required"
                                                            >*</span
                                                        >
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <Input
                                            :labelClass="localFlatInput.labelClass"
                                            :type="localFlatInput.type"
                                            :name="'flat'"
                                            :label="localFlatInput.label"
                                            :required="localFlatInput.required"
                                            v-model="localFlatInput.value"
                                            :isValid="localFlatInput.required ? localFlatInput.isValid : true"
                                            :validationMessage="
                                                localFlatInput.required ? localFlatInput.validationMessage : ''
                                            "
                                            @input="$emit('update:deliveryForm', { name: 'flat', value: $event })" />
                                    </div>
                                    <template v-if="$auth.loggedIn">
                                        <div class="user-addresses" :class="{ flex: $device.isDesktop }">
                                            <div
                                                class="user-address"
                                                :class="{ 'user-address--active': currentDeliveryAddress === 'main' }"
                                                v-if="
                                                    $auth.user.customer.main_address &&
                                                    $auth.user.customer.main_address.city === city.city
                                                "
                                                @click="setDeliveryAddress($auth.user.customer.main_address, 'main')">
                                                <div class="text_9 color-text_2">{{ $t("order_main_address") }}</div>
                                                <div class="text_11">
                                                    {{
                                                        `
                                                    ${
                                                        $auth.user.customer.main_address.city
                                                            ? $auth.user.customer.main_address.city + ", "
                                                            : ""
                                                    }
                                                    ${
                                                        $auth.user.customer.main_address.street
                                                            ? $auth.user.customer.main_address.street + ", "
                                                            : ""
                                                    }
                                                    ${
                                                        $auth.user.customer.main_address.house
                                                            ? $t("house") +
                                                              " " +
                                                              $auth.user.customer.main_address.house +
                                                              ", "
                                                            : ""
                                                    }
                                                    ${
                                                        $auth.user.customer.main_address.building
                                                            ? $t("building") +
                                                              " " +
                                                              $auth.user.customer.main_address.building +
                                                              ", "
                                                            : ""
                                                    }
                                                     ${
                                                         $auth.user.customer.main_address.flat
                                                             ? $t("fl") + " " + $auth.user.customer.main_address.flat
                                                             : ""
                                                     }
                                                `
                                                    }}
                                                </div>
                                            </div>
                                            <div
                                                class="user-address"
                                                :class="{ 'user-address--active': currentDeliveryAddress === 'second' }"
                                                v-if="
                                                    $auth.user.customer.additional_address &&
                                                    $auth.user.customer.additional_address.city === city.city
                                                "
                                                @click="
                                                    setDeliveryAddress($auth.user.customer.additional_address, 'second')
                                                ">
                                                <div class="text_9 color-text_2">{{ $t("order_second_address") }}</div>
                                                <div class="text_11">
                                                    {{
                                                        `
                                                    ${
                                                        $auth.user.customer.additional_address.city
                                                            ? $auth.user.customer.additional_address.city + ", "
                                                            : ""
                                                    }
                                                    ${
                                                        $auth.user.customer.additional_address.street
                                                            ? $auth.user.customer.additional_address.street + ", "
                                                            : ""
                                                    }
                                                    ${
                                                        $auth.user.customer.additional_address.house
                                                            ? $t("house") +
                                                              " " +
                                                              $auth.user.customer.additional_address.house +
                                                              ", "
                                                            : ""
                                                    }
                                                    ${
                                                        $auth.user.customer.additional_address.building
                                                            ? $t("building") +
                                                              " " +
                                                              $auth.user.customer.additional_address.building +
                                                              ", "
                                                            : ""
                                                    }
                                                    ${
                                                        $auth.user.customer.additional_address.flat
                                                            ? $t("fl") +
                                                              " " +
                                                              $auth.user.customer.additional_address.flat
                                                            : ""
                                                    }
                                                `
                                                    }}
                                                </div>
                                            </div>
                                            <div
                                                class="user-address"
                                                :class="{ 'user-address--active': currentDeliveryAddress === 'other' }"
                                                v-if="
                                                    $auth.user.customer.additional_address.city === city.city ||
                                                    $auth.user.customer.main_address.city === city.city
                                                "
                                                @click="setDeliveryAddress()">
                                                <div class="text_9 color-text_2">{{ $t("new_address") }}</div>
                                                <div class="text_11">
                                                    {{ $t("enter_new_address") }}
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <div class="form-group form-group--column">
                                        <label
                                            class="form-group__label delivery-service"
                                            v-for="(service, index) in currentDelivery.services"
                                            :key="index"
                                            :class="{
                                                is_active: currentDeliveryServiceIndex == index && skus,
                                                is_disabled: !skus,
                                                'form-group__label--radio': skus,
                                                'form-group__label--vertical': !$device.isDesktop,
                                            }">
                                            <input
                                                class="form-group__radio"
                                                type="radio"
                                                name="deliveryService"
                                                :value="index"
                                                v-if="skus"
                                                v-model="currentDeliveryServiceIndex" />

                                            <div class="delivery-service__col">
                                                <div class="delivery-service__name">
                                                    <svg-icon
                                                        name="thunder"
                                                        width="7"
                                                        height="11"
                                                        v-if="service.site_name == x_delivery" />
                                                    {{ service.site_name }} / {{ service.vendor }}
                                                </div>
                                                <div
                                                    class="delivery-service__date"
                                                    v-if="!isPreorder && service.delivery_days">
                                                    <span class="color-text_3">{{ $t("deliverty_time") }}:</span>
                                                    <i v-if="service.delivery_days.length == 1">{{ $t("from") }}</i>
                                                    {{ service.delivery_days }}
                                                    <i v-if="service.delivery_days.length == 1">{{
                                                        service.delivery_days | pluralize(daysArr)
                                                    }}</i>
                                                </div>
                                            </div>
                                            <div class="delivery-service__col delivery-service__col--end">
                                                <div class="delivery-service__price">
                                                    {{
                                                        service.cost > 0
                                                            ? service.cost.toLocaleString("ru-RU")
                                                            : $t("free")
                                                    }}
                                                    <span class="money" v-if="service.cost > 0">{{ currency }}</span>
                                                </div>
                                                <div
                                                    class="delivery-service__options color-text_3"
                                                    v-if="service.fitting">
                                                    {{ $t("fitting") }}
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                    <div
                                        class="form-group form-group--info"
                                        v-if="
                                            currentDelivery.services[currentDeliveryServiceIndex] &&
                                            currentDelivery.services[currentDeliveryServiceIndex].free_cost > 0
                                        ">
                                        * закажи на сумму от
                                        {{
                                            currentDelivery.services[currentDeliveryServiceIndex].free_cost
                                                .toLocaleString()
                                                .replace(/,/g, " ")
                                        }}₽, доставка будет за наш счет
                                    </div>
                                    <div class="ems" v-if="currentDeliveryMethod === 'ems'">
                                        <div>
                                            Для подтверждения деталей доставки свяжемся дополнительно по указанным
                                            контактным данным
                                        </div>
                                        <div class="border"></div>
                                        <div>We will contact you to confirm details of delivery</div>
                                    </div>
                                    <template v-if="skus">
                                        <div
                                            class="form-group form-group--delivery-time"
                                            v-for="(group, index) in form[1].groups"
                                            :key="index"
                                            :class="{ 'form-group--column': !$device.isDesktop }">
                                            <template v-for="(input, name, inputIndex) in group">
                                                <template v-if="input.type == 'select'">
                                                    <template>
                                                        <Select
                                                            v-if="
                                                                input.options &&
                                                                Object.keys(input.options).length > 0 &&
                                                                !isPreorder
                                                            "
                                                            :key="'select-' + inputIndex"
                                                            :inputClass="input.inputClass"
                                                            :labelClass="input.labelClass"
                                                            :type="input.type"
                                                            :name="name"
                                                            :label="input.label"
                                                            :required="input.required"
                                                            :options="input.options"
                                                            v-model="input.value"
                                                            :emintOnInit="input.emintOnInit"
                                                            @change="
                                                                $emit('update:deliveryForm', {
                                                                    name: name,
                                                                    value: $event,
                                                                })
                                                            "
                                                            @mounted="
                                                                $emit('update:deliveryForm', {
                                                                    name: name,
                                                                    value: $event,
                                                                })
                                                            " />
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <Input
                                                        :key="'input-' + inputIndex"
                                                        :inputClass="input.inputClass"
                                                        :labelClass="input.labelClass"
                                                        :type="input.type"
                                                        :name="name"
                                                        :label="input.label"
                                                        :required="input.required"
                                                        v-model="input.value"
                                                        :isValid="input.required ? input.isValid : true"
                                                        :validationMessage="
                                                            input.required ? input.validationMessage : ''
                                                        "
                                                        @input="
                                                            $emit('update:deliveryForm', { name: name, value: $event })
                                                        " />
                                                </template>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                                <div v-if="currentDelivery && currentDelivery.method.code == 'pickup'">
                                    <div class="form-group form-group--column">
                                        <label
                                            class="form-group__label delivery-service text_11"
                                            :class="{
                                                is_active: currentDeliveryServiceIndex == index && skus,
                                                'form-group__label--vertical': !$device.isDesktop,
                                                'form-group__label--radio': skus,
                                            }"
                                            v-for="(store, index) in currentDelivery.services.filter(function (el) {
                                                return el.store;
                                            })"
                                            :key="(store && store.store && store.store.id) || index"
                                            @click="changePickup(store, index)">
                                            <div class="delivery-service__col" v-if="skus">
                                                <input
                                                    class="form-group__radio"
                                                    type="radio"
                                                    name="deliveryShop"
                                                    :value="index"
                                                    v-model="currentDeliveryServiceIndex" />
                                            </div>

                                            <div class="delivery-service__col delivery-service__col--grow">
                                                <div class="delivery-service__row">
                                                    <div class="delivery-service__col">
                                                        <div class="delivery-service__name">
                                                            {{ store && store.store && store.store.name }}
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="delivery-service__col delivery-service__col--end"
                                                        v-if="$device.isDesktop">
                                                        <div class="delivery-service__price color-text_3">
                                                            {{ $t("free") }}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="delivery-service__row">
                                                    <div class="delivery-service__col">
                                                        <div class="delivery-service__address">
                                                            <span class="color-text_2">
                                                                {{ store.store && store.store.metro.station }} /
                                                                {{ store.store && store.store.address }}
                                                            </span>
                                                            <span class="color-text_3">
                                                                / {{ store.store && store.store.working_hours[0].day }}
                                                                {{ store.store && store.store.working_hours[0].time }} /
                                                                <span>{{ store.store && store.store.phones[0] }}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    class="delivery-service__row delivery-service__row--last"
                                                    v-if="!$device.isDesktop">
                                                    <div
                                                        class="delivery-service__price"
                                                        :class="{ 'color-text_3': $device.isDesktop }">
                                                        {{ $t("free") }}
                                                    </div>
                                                    <div
                                                        class="delivery-service__date"
                                                        :class="{ 'color-text_3': !$device.isDesktop }">
                                                        {{ store.delivery_in_days }}
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                    <div
                                        class="form-group"
                                        v-if="
                                            Object.keys(form[1].groups[0].shipment_date.options).length > 0 &&
                                            !isPreorder &&
                                            skus
                                        ">
                                        <Select
                                            :key="`shipment_date_${currentDeliveryType}_${currentDeliveryServiceIndex}`"
                                            :inputClass="form[1].groups[0].shipment_date.inputClass"
                                            :labelClass="form[1].groups[0].shipment_date.labelClass"
                                            :type="form[1].groups[0].shipment_date.type"
                                            name="shipment_date"
                                            :label="form[1].groups[0].shipment_date.label"
                                            :required="form[1].groups[0].shipment_date.required"
                                            :options="form[1].groups[0].shipment_date.options"
                                            v-model="form[1].groups[0].shipment_date.value"
                                            :emintOnInit="form[1].groups[0].shipment_date.emintOnInit"
                                            @change="
                                                $emit('update:deliveryForm', { name: 'shipment_date', value: $event })
                                            "
                                            @mounted="
                                                $emit('update:deliveryForm', { name: 'shipment_date', value: $event })
                                            " />
                                    </div>
                                </div>
                                <div v-if="currentDelivery && currentDelivery.method.code == 'pickup_point'">
                                    <div class="pvz relative" name="pvz">
                                        <div :class="{ flex: $device.isDesktop }" v-if="!selectedPvz">
                                            <div
                                                class="pvz__info"
                                                :class="{ is_active: selectedPvzType === 'saved' }"
                                                v-if="savedUserPvz"
                                                @click="setPVZtoUserSavedPVZ()">
                                                <div class="text_9 color-text_2">{{ $t("my_closest_pvz") }}</div>
                                                <div class="text_11">
                                                    {{ savedUserPvz.Name }}<br />
                                                    {{
                                                        savedUserPvz.metro
                                                            ? $t("metro") + " " + savedUserPvz.metro + " / "
                                                            : ""
                                                    }}
                                                    {{ selectedPvz.address }}
                                                </div>
                                            </div>
                                            <div
                                                class="pvz__info"
                                                :class="{ is_active: selectedPvzType === 'new' }"
                                                v-for="(service, index) in currentDelivery.services"
                                                :key="'service-' + service.code"
                                                @click="setPVZtoNewPVZ()">
                                                <div class="flex-c flex-jb">
                                                    <div>
                                                        <div>{{ service.vendor }}</div>
                                                        <div class="delivery-service__date color-text_2">
                                                            {{ $t("deliver_in") }} {{ service.delivery_days }}
                                                            {{ $t("day2") }}
                                                        </div>
                                                        <div class="delivery-service__price">
                                                            <template v-if="service.cost > 0">
                                                                {{ service.cost.toLocaleString("ru-RU") }}
                                                                <span class="money">{{ currency }}</span>
                                                            </template>
                                                            <template v-else>
                                                                {{ $t("free") }}
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div
                                                            class="button button--medium button--centered color-text_1"
                                                            :class="{ 'special-pvz-button': selectedPvz }"
                                                            @click="showPvzModal(service, service.pvz_list, index)">
                                                            {{ $t("select_pvz") }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="selectedPvz" v-if="selectedPvz">
                                            <div class="row flex-row">
                                                <div class="col lg-8 sm-12">
                                                    <div class="pvz-detail__vendor">
                                                        {{ pvzModalService.vendor }}
                                                    </div>
                                                    <div class="pvz-detail__place">
                                                        {{ selectedPvz.address }}
                                                    </div>
                                                    <div class="pvz-detail__address" v-if="selectedPvz.metro">
                                                        {{ $t("metro") }} {{ selectedPvz.metro }}
                                                        <span class="color-text_2">/</span>
                                                        {{ selectedPvz.schedule }}
                                                        <span class="color-text_2">/ {{ selectedPvz.phone }}</span>
                                                    </div>
                                                </div>
                                                <div class="col lg-4 sm-12 col--flex-end" v-if="currentPvzDeliveryInfo">
                                                    <div class="pvz-detail__price">
                                                        <template v-if="currentPvzDeliveryInfo.cost > 0">
                                                            {{ currentPvzDeliveryInfo.cost.toLocaleString("ru-RU") }}
                                                            <span class="money">{{ currency }}</span>
                                                        </template>
                                                        <template v-else>
                                                            {{ $t("free") }}
                                                        </template>
                                                    </div>
                                                    <div class="pvz-detail__date color-text_2">
                                                        {{ $t("deliver_in") }} {{ currentPvzDeliveryInfo.time }}
                                                        {{ currentPvzDeliveryInfo.time | pluralize(daysArr) }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex pvz-detail__buttons">
                                                <div
                                                    class="button button--medium button--dark color-text_1"
                                                    @click="
                                                        showPvzModal(
                                                            pvzModalService,
                                                            pvzFullList,
                                                            currentDeliveryServiceIndex
                                                        )
                                                    ">
                                                    {{ $t("change") }}
                                                </div>
                                                <div
                                                    class="button button--medium"
                                                    :class="{ 'special-pvz-button': selectedPvz }"
                                                    @click="selectedPvz = null">
                                                    {{ $t("cancel") }}
                                                </div>
                                            </div>
                                        </div>
                                        <PvzModal
                                            :vendorCode="pvzModalVendorCode"
                                            :isShowPvzModal="isShowPvzModal"
                                            :pvzFullList="pvzFullList"
                                            :currentPvzDeliveryInfo="currentPvzDeliveryInfo"
                                            :skus="skus"
                                            :currency="currency"
                                            :daysArr="daysArr"
                                            @choosePvz="choosePvz($event)"
                                            @update:isShowPvzModal="isShowPvzModal = $event"
                                            @update:currentPvz="
                                                currentPvzIndex = $event.index;
                                                currentPvz = $event.pvz;
                                            " />
                                        <div v-if="pvzError" class="form-group__validation text_11">
                                            {{ pvzError }}
                                        </div>
                                        <div
                                            class="form-group form-group--info"
                                            v-if="
                                                currentDelivery.services[currentDeliveryServiceIndex] &&
                                                currentDelivery.services[currentDeliveryServiceIndex].free_cost > 0
                                            ">
                                            * закажи на сумму от
                                            {{
                                                currentDelivery.services[currentDeliveryServiceIndex].free_cost
                                                    .toLocaleString()
                                                    .replace(/,/g, " ")
                                            }}₽, доставка будет за наш счет
                                        </div>
                                    </div>
                                </div>
                                <div class="delivery__footer" v-if="!skus">
                                    <ul class="delivery__footer--list color-text_3">
                                        <li
                                            class="delivery__footer--item"
                                            v-for="(item, index) in currentDelivery.method.common_rules"
                                            :key="index">
                                            {{ item }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
                <div class="delivery__no-delivery" key="no-delivery" v-else>
                    <div class="delivery-help text_11">
                        <div class="delivery-help__error">{{ $t("no_delivery_here") }}</div>
                        <div
                            class="delivery-help__hint"
                            v-if="
                                $store.getters['globalvars/getShowContactPhone'] &&
                                $store.getters['globalvars/getLang'] &&
                                $store.getters['globalvars/getLang'] === 'ru'
                            ">
                            {{ $t("call_us_phone") }}
                            <a :href="'tel:' + $store.getters['globalvars/getContactPhone']">{{
                                $store.getters["globalvars/getContactPhone"]
                            }}</a>
                            {{ $t("we_help_make_order") }}
                        </div>
                    </div>
                    <!-- <p>К сожалению для вас нет подходящего способа доставки</p>
                    <p>Вы можете оформить заказ и наш менеджер свяжется с вами для решения всех вопросов</p>
                    <div class="button button--dark button--large text_13" @click="sendOrder(true)">оформить заказ</div> -->
                </div>
            </template>
            <transition name="fade">
                <div class="shops-map-modal" v-if="isShowMap">
                    <div class="shops-map-modal__close" @click="isShowMap = false">
                        <svg-icon name="close" width="32" height="32" />
                    </div>
                    <div class="shops-map-modal__content">
                        <StoresMap :stores="this.stores" :activeMarkerIndex="activeMarkerIndex" :isMapOnly="true" />
                    </div>
                </div>
            </transition>
        </div>
        <div class="inline-loader" key="2" v-else :style="loadingStyles"></div>
    </div>
</template>
<script>
import Input from "~/components/form/Input";
import Select from "~/components/form/Select";
import StoresMap from "~/components/StoresMap";
import PvzModal from "~/components/PvzModal";
import { mapGetters, mapMutations, mapState } from "vuex";
export default {
    name: "Deliveries",
    props: [
        "pvzError",
        "isPreorder",
        "city",
        "orderCountry",
        "skus",
        "locale",
        "street",
        "streetInput",
        "building",
        "buildingInput",
        "flat",
        "flatInput",
        "changeCityValue",
        "changeAddress",
        "beltwayHit",
        "itemsPrice",
        "isCIS",
        "comment",
        "formCurrentDeliveryMethod",
        "formCurrentDeliveryServiceIndex",
        "formCurrentDeliveryType",
        "shipmentDate",
        "shipmentTime",
        "initDeliveries",
        "initPayType",
        "initPvz",
    ],
    components: {
        Input,
        Select,
        StoresMap,
        PvzModal,
    },
    data() {
        return {
            mounted: false,
            isShowMap: false,
            deliveries: null,
            currentDeliveryServiceIndex: null,
            activeMarkerIndex: 0,
            currentDeliveryType: null,
            currentDeliveryMethod: null,
            pvzAddress: "",
            isShowPvzModal: false,
            pvzModalVendorCode: null,
            pvzModalService: null,
            pvzFullList: null,
            activePvzMarkerIndex: false,
            currentPvzIndex: false,
            currentPvzDeliveryInfo: null,
            selectedPvz: null,
            currentPvz: false,
            currentDeliveryAddress: "other",
            selectedPvzType: "new",
            savedUserPvz: null,
            suggestions: [],
            is_changed: false,
            is_focus: false,
            query: "",
            timeout: null,
            wasSelected: false,
            form: [
                {
                    groups: [
                        {
                            building: {
                                label: this.$i18n.t("house"),
                                required: true,
                                isValid: true,
                                validationMessage: "",
                                labelClass: this.$device.isDesktop
                                    ? "form-group__label--quart"
                                    : "form-group__label--half",
                                value: "",
                            },
                            flat: {
                                label: this.$i18n.t("fl_of"),
                                labelClass: this.$device.isDesktop
                                    ? "form-group__label--quart"
                                    : "form-group__label--half",
                                value: "",
                            },
                            street: {
                                label: "street",
                                value: "",
                            },
                        },
                    ],
                },
                {
                    groups: [
                        {
                            shipment_date: {
                                label: this.$i18n.t("delivery_date"),
                                required: true,
                                isValid: true,
                                validationMessage: "",
                                labelClass: this.$device.isDesktop ? "form-group__label--quart" : "",
                                type: "select",
                                value: this.shipmentDate || "0",
                                options: {},
                                emintOnInit: true,
                            },
                            shipment_time: {
                                label: this.$i18n.t("delivery_time"),
                                required: true,
                                isValid: true,
                                validationMessage: "",
                                labelClass: "form-group__label--quart",
                                type: "select",
                                value: this.shipmentTime || "",
                                emintOnInit: true,
                                options: {},
                            },
                            comment: {
                                label: this.$i18n.t("comm_to_order"),
                                value: this.comment || "",
                            },
                        },
                    ],
                },
            ],
            localStreetInput: {},
            localBuildingInput: {},
            localFlatInput: {},
            loadingStyles: {
                height: "500px",
            },
        };
    },
    computed: {
        ...mapGetters({
            currency: "globalvars/getCurrency",
            langust: "globalvars/getLang",
            currencyCode: "globalvars/getCurrencyCode",
            statusPpsCourier: "globalvars/getStatusPpsCourier",
            statusPpsCourierPreorderPayment: "globalvars/getStatusPpsCourierPreorderPayment",
        }),
        ...mapGetters("order", ["isDeliveresLoading"]),
        isShowStreetSuggestions() {
            return this.localStreetInput.is_focus && this.localStreetInput.is_changed;
        },
        isShowBuildingSuggestions() {
            return this.localBuildingInput.is_focus && this.localBuildingInput.is_changed;
        },

        re() {
            return new RegExp(this.query, "gi");
        },
        moskow() {
            return this.$i18n.t("moskow");
        },
        x_delivery() {
            return this.$i18n.t("x_delivery");
        },
        daysArr() {
            return [this.$i18n.t("day1"), this.$i18n.t("day2"), this.$i18n.t("day5")];
        },
        pointArr() {
            return [this.$i18n.t("point1"), this.$i18n.t("point2"), this.$i18n.t("point5")];
        },
        stores() {
            if (this.currentDeliveryType == "pickup") {
                let service = this.deliveries.find((item) => {
                    return item.method.code == "pickup";
                });
                if (service) {
                    if (service.services) {
                        let stores = [];
                        for (let index = 0; index < service.services.length; index++) {
                            const element = service.services[index];
                            stores.push(element.store);
                        }
                        return stores;
                    }
                }
            }
            return [];
        },
        currentDelivery() {
            if (this.deliveries) {
                return this.deliveries.filter((item) => item.method.slug == this.currentDeliveryMethod)[0];
            }
            return null;
        },
    },
    watch: {
        currentPvzIndex(val) {
            if (val !== false) {
                this.getCurrentPvzDeliveryInfo(this.currentPvz);
            }
        },
        currentDeliveryServiceIndex(newVal) {
            if (this.mounted) {
                this.$emit("update:currentDeliveryServiceIndex", newVal);
                this.$emit("update:payType", this.deliveries?.[0]?.services[0].payment_types[0].id || null);
                if (newVal !== null) {
                    console.log(`2 =>`);

                    this.setCourierDates(this.currentDeliveryType, newVal);
                }
            }
        },
        currentDeliveryType(newVal) {
            if (this.mounted) {
                this.$emit("update:currentDeliveryType", newVal);
                this.setCourierDates(newVal, this.currentDeliveryServiceIndex);
            }

            this.$emit("update:payType", this.deliveries?.[0].services[0].payment_types[0].id || null);
        },
        currentDeliveryMethod(newVal) {
            this.$emit("update:currentDeliveryMethod", newVal);
        },
        city(newVal) {
            if (this.mounted) {
                this.$emit("resetStreet");
                this.$emit("update:payType", null);
                this.$emit("update:currentDeliveryServiceIndex", null);
                this.$emit("update:currentDeliveryType", null);
                this.$emit("update:currentDeliveryMethod", null);
                this.$emit("update:deliveries", null);
                this.showDeliveries(newVal);
            }
        },

        streetInput: {
            handler(v) {
                this.localStreetInput = JSON.parse(JSON.stringify(v));
            },
            deep: true,
        },
        buildingInput: {
            handler(v) {
                this.localBuildingInput = JSON.parse(JSON.stringify(v));
            },
            deep: true,
        },
        flatInput: {
            handler(v) {
                this.localFlatInput = JSON.parse(JSON.stringify(v));
            },
            deep: true,
        },
        locale() {
            if (this.mounted) {
                this.showDeliveries(this.city);
            }
        },
        resetting(val) {
            if (val) {
                this.is_changed = false;
                this.value = "";
                this.$emit("update:resetting", false);
            }
        },
        country() {
            if (this.initValue == "") {
                this.$emit("reset");
                this.$emit("reset");
                this.suggestions = [];
                this.is_changed = false;
                this.value = "";
            }
        },
        isFocus(val) {
            if (val) {
                this.$emit("focus");
            } else {
                this.$emit("blur");
            }
        },
    },
    methods: {
        ...mapMutations("order", ["setIsDeliveresLoading"]),
        setWasSelected(value) {
            this.wasSelected = value;
        },
        checkValue() {
            if (this.initValue == "") {
                var obj = this;
                setTimeout(function () {
                    if (obj.wasSelected == false) {
                        obj.street.value = "";
                        obj.is_focus = false;
                    }
                }, 200);
            }
        },
        select(data) {
            // this.street.value = data.data.street_with_type;
            this.form[0].groups[0].street.value = data.data.street_with_type;
            this.$emit("update:deliveryForm", { name: "street", value: data.data.street_with_type });
            this.setWasSelected(true);
        },
        getCurrentPvzDeliveryInfo(pvz) {
            if (pvz) {
                let q = {
                    delivery_type_id: pvz.serviceId,
                    pvz_code: pvz.code,
                    skus: this.skus,
                    no_sku: this.skus ? "0" : "1",
                    currency: this.currencyCode,
                };
                if (pvz.zip) q.zip = pvz.zip;
                this.$axios
                    .get("/api/deliveries/pvz/calculate?" + this.$grom.objToParams(q))
                    .then((res) => {
                        this.currentPvzDeliveryInfo = res.data;
                        this.deliveries.filter((item) => item.method.code == this.currentDeliveryType)[0].services[
                            this.currentDeliveryServiceIndex
                        ].cost = this.currentPvzDeliveryInfo.cost;
                    })
                    .catch((err) => {
                        console.log(`err =>`, err);
                    });
            } else {
                this.currentPvzDeliveryInfo = null;
                this.deliveries.filter((item) => item.method.code == this.currentDeliveryType)[0].services[
                    this.currentDeliveryServiceIndex
                ].cost = "";
            }
        },
        changePickup(store, index) {
            this.skus ? (this.activeMarkerIndex = index) : this.$emit("update:currentShop", store);
        },
        setPVZtoUserSavedPVZ() {
            this.selectedPvzType = "saved";
            this.$emit("update:pvz", this.savedUserPvz);
            this.selectedPvz = this.savedUserPvz;
            this.getCurrentPvzDeliveryInfo(this.savedUserPvz);
        },
        setPVZtoNewPVZ() {
            if (this.currentPvz && this.selectedPvzType === "saved") {
                this.choosePvz(this.currentPvz);
                this.getCurrentPvzDeliveryInfo(this.currentPvz);
            } else {
                this.selectedPvz = null;
            }
            this.selectedPvzType = "new";
        },
        setDeliveryAddress(address = false, type = "other") {
            this.currentDeliveryAddress = type;
            if (type !== "other") {
                this.$props.changeAddress({
                    street: this.street || address.street,
                    // добавляем строение к номеру дома (если есть)
                    building: this.building || address.building,
                    flat: this.flat || address.flat,
                });
            } else {
                this.$props.changeAddress({
                    street: "",
                    // добавляем строение к номеру дома (если есть)
                    building: "",
                    flat: "",
                });
            }
        },
        setUserAddress() {
            if (!this.$auth.loggedIn) {
                return;
            }

            if (this.$auth.user.customer.main_address) {
                this.setDeliveryAddress(this.$auth.user.customer.main_address, "main");
                return;
            } else if (this.$auth.user.customer.additional_address) {
                this.setDeliveryAddress(this.$auth.user.customer.additional_address, "second");
                return;
            } else {
                this.setDeliveryAddress(false, "other");
                return;
            }
        },
        getRequestQuery(data) {
            console.log(`data getRequestQuery =>`, data);
            return {
                iso_code: data.data.region_iso_code,
                kladr: data.data.city_kladr_id
                    ? data.data.city_kladr_id
                    : data.data.kladr_id
                    ? data.data.kladr_id
                    : null,
                fias: data.data.fias_id || data.data.city_fias_id || null,
                city: data.city ? data.city : data.data.settlement,
                city_geohelper_id: data.geohelper ? data.geohelper.id : 0,
                region: {
                    id: data.geohelper ? data.geohelper.regionId : "",
                    name: data.data.region + " " + data.data.region_type_full,
                },
                skus: this.skus,
                no_sku: this.skus ? "0" : "1",
                zip_code: this.zip_code,
                currency: this.currencyCode,
                street: this.street,
                building: this.building,
                status_pps_courier: this.beltwayHit === "OUT_MKAD",
                status_pps_courier_preorder_payment: this.statusPpsCourierPreorderPayment,
            };
        },
        async showDeliveries(data, resetCurrentData = true) {
            if (this.$refs["delivery_container"]) {
                this.loadingStyles.height = this.$refs["delivery_container"].offsetHeight + "px";
            }

            this.setIsDeliveresLoading(true);
            console.log(`data =>`, data);
            if (data) {
                this.zip_code = data.data.postal_code ? data.data.postal_code : data.zip_code;
                const q = this.getRequestQuery(data);
                this.$emit("update:orderRequest", q);
                try {
                    const res = await this.$axios.get("/api/deliveries?" + this.$grom.objToParams(q));
                    this.deliveries = res.data;
                    if (res.data.length > 0) {
                        this.currentDeliveryServiceIndex = this.currentDeliveryServiceIndex ?? 0;
                        this.currentDeliveryMethod = this.formCurrentDeliveryMethod
                            ? this.formCurrentDeliveryMethod
                            : res.data[0].method.slug;
                        this.currentDeliveryType = this.currentDeliveryType ?? res.data[0].method.code;

                        this.setCourierDates(this.currentDeliveryType, this.currentDeliveryServiceIndex);

                        // обновляем способ оплаты
                        if (resetCurrentData) {
                            this.$emit("update:payType", res.data[0].services[0].payment_types[0].id);
                            this.$emit("update:currentDeliveryServiceIndex", 0);
                            this.$emit("update:currentDeliveryType", res.data[0].method.code);
                            this.$emit("update:currentDeliveryMethod", res.data[0].method.slug);
                        }

                        // ищем пвз пользователя по имени
                        if (this.$auth.loggedIn && this.$auth.user.customer.pickup_point_address.city) {
                            this.deliveries.forEach((del) => {
                                if (del.method.code === "pickup_point") {
                                    del.services.forEach((ser) => {
                                        ser.pvz_list.forEach((pvz) => {
                                            // поскольку пвз сохраняется как обычный адрес я записываю его назание в поле building
                                            if (pvz.Name == this.$auth.user.customer.pickup_point_address.building) {
                                                this.savedUserPvz = pvz;
                                            }
                                        });
                                    });
                                }
                            });
                        }
                    } else {
                        this.currentDeliveryServiceIndex = 0;
                        this.currentDeliveryMethod = null;
                    }
                    this.$emit("update:deliveries", this.deliveries);
                } catch (err) {
                    console.log(`err =>`, err);
                }
            } else {
                this.deliveries = null;
                this.currentDeliveryServiceIndex = 0;
                this.currentDeliveryMethod = null;
                this.$emit("update:deliveries", this.deliveries);
            }
            this.setIsDeliveresLoading(false);
        },
        setCourierDates(typeCode, methodIndex, silent = false) {
            this.form[1].groups[0].shipment_date.options = {};
            this.form[1].groups[0].shipment_date.value = "";
            this.form[1].groups[0].shipment_time.options = {};
            this.form[1].groups[0].shipment_time.value = "";
            if (this.deliveries) {
                let service = this.deliveries.find((item) => {
                    return item.method.code == typeCode;
                });

                if (service) {
                    if (service.services[methodIndex]) {
                        if (service.services[methodIndex].delivery_dates) {
                            let options = {};
                            const dates = Object.keys(service.services[methodIndex].delivery_dates);

                            dates.forEach((date) => {
                                options[date] = service.services[methodIndex].delivery_dates[date].date;
                            });

                            this.form[1].groups[0].shipment_date.options = options;

                            const timeOptions = service.services[methodIndex].delivery_dates[dates[0]].time_intervals;

                            this.form[1].groups[0].shipment_time.options = timeOptions;

                            if (dates.length > 0) {
                                this.form[1].groups[0].shipment_date.value = dates[0];
                            }

                            const timeKeys = Object.keys(timeOptions);
                            if (timeKeys.length > 0) {
                                this.form[1].groups[0].shipment_time.value = timeKeys[0];
                            }
                        }
                    }
                }
            }
            if (this.mounted) {
                this.$emit("update:deliveryForm", {
                    name: "shipment_date",
                    value: this.form[1].groups[0].shipment_date.value,
                });
                this.$emit("update:deliveryForm", {
                    name: "shipment_time",
                    value: this.form[1].groups[0].shipment_time.value,
                });
            }
        },
        choosePvz(pvz) {
            this.$emit("update:pvz", pvz);
            this.selectedPvz = pvz;
            this.isShowPvzModal = false;
            this.activePvzMarkerIndex = false;
            this.currentPvzIndex = false;
        },
        showPvzModal(service, pvzList, serviceIndex) {
            this.currentDeliveryServiceIndex = serviceIndex;
            this.pvzModalVendorCode = service.vendor_code;
            this.pvzModalService = service;
            console.log(`service =>`, service);
            this.pvzFullList = pvzList;
            this.isShowPvzModal = true;
        },
        copyAddress() {
            this.localStreetInput = JSON.parse(JSON.stringify(this.streetInput));
            this.localBuildingInput = JSON.parse(JSON.stringify(this.buildingInput));
            this.localFlatInput = JSON.parse(JSON.stringify(this.flatInput));
        },
    },
    async mounted() {
        if (this.initDeliveries) {
            const payType = this.initPayType;
            const localTime = this.shipmentTime;
            const localDate = this.shipmentDate;
            this.deliveries = this.initDeliveries;
            this.currentDeliveryServiceIndex = this.formCurrentDeliveryServiceIndex;
            this.currentDeliveryType = this.formCurrentDeliveryType;
            this.currentDeliveryMethod = this.formCurrentDeliveryMethod;

            if (this.initPvz) {
                let service = this.deliveries.find((item) => {
                    return item.method.code == this.currentDeliveryType;
                });
                if (service) {
                    this.pvzModalService = service.services[this.currentDeliveryServiceIndex];
                    this.pvzModalVendorCode = this.pvzModalService.vendor_code;
                    this.selectedPvz = this.initPvz;
                    this.pvzFullList = this.pvzModalService.pvz_list;
                }
            }
            this.setCourierDates(this.currentDeliveryServiceIndex, this.currentDeliveryType);
            setTimeout(() => {
                this.form[1].groups[0].shipment_date.value = localDate;
                this.form[1].groups[0].shipment_time.value = localTime;
                this.$emit("update:payType", payType || null);
            }, 200);
            const q = this.getRequestQuery(this.city);
            this.$emit("update:orderRequest", q);
        } else if (this.city && !this.street) {
            await this.showDeliveries(this.city);
        }

        if (this.initValue) {
            this.value = this.initValue;
            this.is_changed = true;
        }
        this.setUserAddress();
        this.copyAddress();

        this.mounted = true;

        if (this.street) {
            this.showDeliveries(this.city, false);
        }
    },
};
</script>
<style type="text/css">
.dadata-street:empty:before {
    content: "Улица не найдена";
    padding: 8px 24px;
    color: #a6a6a6;
}
</style>
<style lang="less" scoped>
.shops-map-modal {
    position: fixed;
    top: 73px;
    bottom: 0;
    left: 58.3333333%;
    right: 0;
    z-index: 7;
    background: url(../assets/icons/loader.svg) center no-repeat, @bg;
    @media @sm {
        left: 0;
        top: 37px;
    }
    &__close {
        width: 39px;
        height: 39px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px #000 solid;
        background: #fff;
        position: absolute;
        right: 16px;
        top: 16px;
        z-index: 8;
        cursor: pointer;
        .trs(all);
        &:hover {
            background: @accent;
            border-color: @accent;
            svg {
                filter: invert(1);
            }
        }
        svg {
            display: block;
            .trs(all);
        }
    }
    &__content {
        height: 100%;
        .row {
            height: 100%;
        }
    }
}
.delivery {
    margin-top: 40px;
    position: relative;
    z-index: 3;
    .ems {
        margin-top: 34px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        text-align: center;
        .border {
            border-bottom: 1px solid #000000;
        }
    }
    &__no-delivery {
        p {
            margin-bottom: 16px;
        }
    }
    &__tabs {
        display: flex;
        align-items: center;
        overflow-x: auto;
        @media @sm {
            align-items: stretch;
        }
    }
    &__tab {
        padding: 16px 24px;
        cursor: pointer;
        outline: 1px @border2 solid;
        outline-offset: -1px;
        .trs(outline);
        & + & {
            margin-left: -1px;
        }
        @media @sm {
            width: 100%;
            text-align: center;
            display: flex;
            align-items: center;
            padding: 8px 23px;
            justify-content: center;
        }
        &.is_active,
        &:hover {
            outline: 1px #000 solid;
            position: relative;
            z-index: 1;
        }
        &.is_disabled {
            pointer-events: none;
            opacity: 0.5;
        }
    }
    &__contents {
        @media @sm {
            margin-top: 16px;
            .delivery-shops-modal-toggler + & {
                margin-top: 0;
            }
        }
    }
    &__content {
        &--pickup {
            @media @sm {
                > .form-group {
                    + .form-group {
                        margin-top: 16px;
                    }
                }
            }
        }
    }
    &__footer {
        margin-top: 64px;
        @media @sm {
            margin-top: 24px;
            margin-bottom: 24px;
        }
        &--item {
            display: flex;
            margin-bottom: 8px;
            &:before {
                content: "";
                background: url(../assets/icons/dots.svg);
                width: 6px;
                height: 6px;
                display: block;
                margin-right: 8px;
                position: relative;
                top: 4px;
                flex-shrink: 0;
            }
        }
    }
}
.delivery-shops-modal-toggler {
    margin-left: auto;
    cursor: pointer;
    &:hover {
        color: @text_3;
    }
    @media @sm {
        padding: 32px;
        width: 100%;
        margin-left: 0;
        text-align: center;
    }
}
.delivery-service {
    padding: 16px 24px;
    outline: 1px @border2 solid;
    outline-offset: -1px;
    margin-top: 40px;
    flex-direction: row;
    cursor: pointer;
    .trs(outline);
    & + & {
        margin-top: -1px;
    }
    @media @sm {
        position: relative;
        margin-top: 0;
        flex-direction: column;
        &.form-group__label--radio {
            padding-left: 64px;
        }
        & + & {
            margin-top: -1px;
            margin-left: 0;
        }
        .form-group__radio {
            position: absolute;
            top: 16px;
            left: 24px;
        }
    }
    &.is_active,
    &:hover {
        outline: 1px #000 solid;
        z-index: 1;
        position: relative;
    }
    &.is_disabled {
        outline: 1px @border2 solid !important;
        cursor: default;
    }
    &__col {
        // flex-shrink: 0;
        @media @sm {
            flex-shrink: 1;
        }
        &--end {
            margin-left: auto;
            text-align: right;
            @media @sm {
                margin-left: 0;
                margin-top: 16px;
                text-align: left;
            }
        }
        &--grow {
            flex-grow: 1;
        }
    }
    &__row {
        display: flex;
        flex-grow: 1;
        align-items: center;
        @media @sm {
            align-items: flex-start;
            & + & {
                margin-top: 8px;
                &--last {
                    margin-top: 16px;
                    flex-direction: column;
                }
            }
        }
    }
    &__name {
        display: flex;
        align-items: center;
        svg {
            margin-right: 7px;
        }
    }
    &__options {
        margin-top: 4px;
    }
    &__address {
        span {
            span {
                white-space: nowrap;
            }
        }
        .is_active & {
            span {
                color: #000;
                span {
                    color: @text_3;
                }
            }
        }
    }
    &__date {
        margin: 8px 0;
        @media @sm {
            span {
                display: block;
            }
        }
    }
}

.pickup {
    border: 1px @border2 solid;
    padding: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 24px;
    .button {
        margin-top: 16px;
    }
}
.form-group--delivery-time {
    padding-top: 4px;
    @media @sm {
        .form-group__label {
            & + .form-group__label {
                margin-top: 24px;
            }
        }
    }
}
.form-group--address {
    display: flex;
    flex-wrap: wrap;
    gap: 0 20px;

    .dadata-suggestions:first-child {
        flex-basis: 300px;
    }
    .dadata-suggestions,
    .form-group__label {
        flex-basis: 180px;
        flex-grow: 1;
    }
    @media @sm {
        margin-bottom: 32px;
        flex-wrap: wrap;
        .form-group__label {
            & + .form-group__label {
                margin-left: 0;
            }
            &--half {
                width: calc(50% - 8px);
                & + .form-group__label--half {
                    margin-left: 16px;
                }
            }
        }
    }
}

.delivery-help {
    margin-top: -32px;
    &__hint {
        padding: 16px;
        border: 1px solid @border2;
        text-align: center;
        margin-top: 32px;
    }
}
.pvz {
    margin-top: 24px;
    .form-group__label {
        margin-top: 27px;
    }
    &__info {
        padding: 16px 24px;
        border: 1px @border2 solid;
        width: 50%;
        font-weight: 400;
        font-size: 11px;
        font-size: 11px;
        line-height: 140%;
        letter-spacing: 1.76px;
        @media @sm {
            width: 100%;
            .flex-c {
                flex-direction: column;
                align-items: flex-start;
                gap: 8px;
            }
        }
        .text_9 {
            margin-bottom: 8px;
        }
        .button {
            margin-left: 15px;
            width: 118px;
            white-space: nowrap;
            @media @sm {
                margin-left: 0;
            }
            &.special-pvz-button {
                flex-direction: column;
                padding-top: 8px;
                padding-bottom: 8px;
                height: auto;
            }
        }
    }
    &__left {
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .container {
            flex-grow: 0;
        }
    }
    .pvz-detail__buttons {
        justify-content: space-between;
        gap: 4px;
    }
}
.selectedPvz {
    margin-top: 24px;
    border: 1px #000 solid;
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    .button {
        max-width: 97px;
    }
}
.user-addresses {
    margin-top: 40px;
}
.user-address {
    padding: 16px 24px;
    border: 1px @border2 solid;
    margin-right: -1px;
    width: 100%;
    cursor: pointer;
    @media @sm {
        margin-top: -1px;
        margin-right: 0;
    }
    &--active {
        border-color: #000;
        position: relative;
        z-index: 1;
    }
    .text_9 {
        margin-bottom: 8px;
    }
}

.col--flex-end {
    justify-content: flex-end;
}
</style>
